import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { ActivatedRoute } from '@angular/router';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { StandingsDialogComponent } from './standings.dialog.component';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'slip-detail-component',
  templateUrl: '../sharedTemplates/slip-detail.component.html',
})
export class SlipDetailComponent implements OnInit, AfterViewInit {
  slipId: number;
  slipDetailList = [];
  couponDetailList = [];
  today = new Date();

  @Input() inputSlipId = 0;
  @Input() inputStateId = 1;
  constructor(
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private route: ActivatedRoute,
    private _DataHelper: DataHelper,
    public _LZ: LocalizationService,
    private _Router: Router,
    public dialog: MatDialog,
    public _LocalizationService: LocalizationService
  ) {}

  ngOnInit() {
    if (this.inputSlipId == 0) {
      this.route.params.subscribe(params => {
        this.slipId = params['slipid'];
        ////console.log("SLIP_ID", this.slipId);
      });
    } else {
      this.slipId = this.inputSlipId;
      this.getSlipDetail();
    }
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('betting_slip_details');
  }
  // getScroll()
  // {
  //   this.scrollcord = document.getElementById('main-slip-container')
  //   this.scrollcord.scrollIntoView()

  // }
  getSlipDetail() {
    this._ApiService.getSlipDetail(this.slipId).then(x => {
      if (x == undefined) return;
      if (x == '') return;

      this.slipDetailList = x;
      // console.warn("slipDetailList",this.slipDetailList)
    });

    this._ApiService.getCouponDetailBySlipId(this.slipId).then(x => {
      if (x == undefined) return;
      if (x == '') return;

      this.couponDetailList = x;
      // console.warn("couponDetailList",this.couponDetailList)
    });
  }

  slipRestore() {
    this._ApiService.slipRestore(this.slipId).then(x => {
      if (x == '1') {
        // window.location.href = "/home";
        this._Router.navigate(['/home']);
      }
    });
  }

  slipRestoreB3000() {
    this._ApiService.slipRestore(this.slipId).then(x => {
      this._UiHelper.b3000SetAcountMobileState('close');

      this._UiHelper.b3000SetBottomDialogState('open');
    });
  }

  getLiveEvent(e) {
    if (this._DataHelper.liveData != undefined) {
      const match = this._DataHelper.liveData.find(m => m.BetradarMatchId == e);
      //  console.warn("match",match)

      return match;
    }
  }

  goLiveEventDetail(e) {
    this._Router.navigate(['/liveeventdetail', e]);
  }

  goEventDetail(e) {
    this._Router.navigate(['/eventdetail', e]);
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else return e;
  }
  // goDetail(selectedEvent) {
  //   // console.warn('Selected ', selectedEvent);
  //   let translator = new TranslatePipe(this._LocalizationService);
  //   console.warn("selectedEvent", selectedEvent);
  //   if (selectedEvent.IsLive == true) {
  //     if (selectedEvent.MatchStatus == "Ende") {
  //       this.openStatsDialog(selectedEvent.BetradarMatchId);
  //       return;
  //     }

  //     this._DataHelper.selectedMatch = { GroupName: "", IsoName: "" };
  //     this._DataHelper.selectedMatch.GroupName = translator.transform(
  //       "MyBets",
  //       null
  //     );
  //     this._DataHelper.selectedMatch.IsoName = "";
  //     this.goLiveEventDetail(selectedEvent.EventId);
  //   } else {
  //     if (
  //       selectedEvent != undefined &&
  //       selectedEvent.MatchStatus == "" &&
  //       selectedEvent.State != ""
  //     ) {
  //       this.openStatsDialog(selectedEvent.BetradarMatchId);
  //       return;
  //     }

  //     this._DataHelper.selectedMatch = { TournamentName: "", IsoName: "" };

  //     this._DataHelper.selectedMatch.TournamentName = translator.transform(
  //       "MyBets",
  //       null
  //     );

  //     this._DataHelper.selectedMatch.IsoName = "";

  //     this.goEventDetail(selectedEvent.EventId);
  //   }
  // }
  openStatsDialog(betradarMatchId) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: betradarMatchId,
        type: 'endedmatchresult',
      },
    });
  }
  goMatchDetail(match) {
    const today = new Date();
    const eventDateIso = new Date(match.EventDateIso);
    // Pre Match Live a geçtikten sonra
    if (!match.IsLive && today > eventDateIso) {
      if (match != undefined && match.MatchStatus != '' && match.State != '') {
        this.openStatsDialog(match.BetradarMatchId);

        // this._UiHelper.b3000SetAcountMobileState("close");

        return;
      } else {
        this.goLiveEventDetail(match.MatchId);
        this._UiHelper.b3000SetAcountMobileState('close');
        return;
      }
    }

    if (match.IsLive) {
      this.goLiveEventDetail(match.MatchId);
    } else {
      if (match != undefined && match.MatchStatus != '' && match.State != '') {
        this.openStatsDialog(match.BetradarMatchId);

        return;
      } else {
        this.goEventDetail(match.MatchId);
        this._UiHelper.b3000SetAcountMobileState('close');
      }
    }
  }
}
